export default __webpack_public_path__ + "static/media/job_5.6eaf06c6.png";